<template>
  <footer>
    placeholder
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  components: {
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

footer {
}
</style>
